var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.iframeAllowed)?_c('iframe',{attrs:{"id":"analytics-iframe","src":_vm.iframeUrl,"width":"100%","height":"1800","frameborder":"0"}}):_c('div',[_vm._v("\r\n        This page cannot be embedded due to security restrictions.\r\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }